import { Capability } from '@repo/utils/auth';

/** Who opens a set's page: a reader who browses sets, or one who runs them without changing them. */
export const QUIZ_SET_CAPABILITIES: Capability[] = [
  Capability.QuestionSetsView,
  Capability.QuizzesRun,
];
